import {AfterViewChecked, Component, ElementRef, Input, OnDestroy, OnInit, Renderer2, ViewChild} from '@angular/core';
import {tap} from "rxjs/operators";
import {School} from "../../../model/rest/casa-apiv2.model";
import { TransactionsV3RestService } from "../../../services/rest/v3/transactions-rest.service";
import {MappedProductWarehouseEntry} from "../../../model/v3/transactions";

@Component({
    selector: 'app-credits-summary-block',
    templateUrl: './credits-summary-block.component.html',
    styleUrls: ['./credits-summary-block.component.css'],
    standalone: false
})
export class CreditsSummaryBlockComponent implements OnInit, OnDestroy, AfterViewChecked {
  private mSchool: School;
  private credits: MappedProductWarehouseEntry[];
  contentFoggy: boolean
  initialHeight: string

  @Input()
  set school(value: School) {
    this.mSchool = value;
    if (!value || !value.id) return;
    this.reload();
  }

  @ViewChild('ebookCreditsCard') card: ElementRef
  @ViewChild('cardHeightPlaceholder') cardHeightPlaceholder: ElementRef

  constructor(
    private transactionsRest: TransactionsV3RestService,
    private renderer: Renderer2) { }

  ngOnInit() {
  }

  ngOnDestroy(): void {
  }
  ngAfterViewChecked(): void {
    if(!this.initialHeight && this.card)
      this.initialHeight = `${this.card?.nativeElement.offsetHeight}px`
    if(this.initialHeight && !this.cardHeightPlaceholder.nativeElement.style.height) {
      this.renderer.setStyle(
        this.cardHeightPlaceholder.nativeElement,
        'height',
        this.initialHeight
      )
    }
  }

  private reload() {
    this.loadCredits(this.mSchool.id)
      .pipe(
        tap( credits => this.store(credits))
      )
      .subscribe();
  }

  private loadCredits(schoolId: number) {
    return this.transactionsRest.getSchoolCredits(schoolId);
  }

  private store(credits: MappedProductWarehouseEntry[]) {
    this.credits = credits;
    this.contentFoggy = this.credits.length > 4
  }

  isReady() {
    return this.credits;
  }

  hasCredits() {
    return this.credits.length > 0;
  }

  isContentFoggy() {
    return this.contentFoggy
  }

  isContentExpanded() {
    return !this.contentFoggy && this.getCreditsEntries().length > 4
  }

  toggleContentFoggy() {
    this.contentFoggy = !this.contentFoggy
  }

  getCreditsEntries(): MappedProductWarehouseEntry[] {
    return this.credits;
  }
  getCreditsEntriesSorted(): MappedProductWarehouseEntry[] {
    return [
      this.getCreditEntry('en-r3'),
      this.getCreditEntry('en'),
      this.getCreditEntry('sp'),
      this.getCreditEntry('bs'),
      this.getCreditEntry('cfk'),
    ].filter(it => it)
  }

  getCreditEntry(productCode: string): MappedProductWarehouseEntry {
    return this.credits.find(credit => credit.product.mappedId.endsWith(productCode))
  }

  getEntryDescription(entry: MappedProductWarehouseEntry) {
    if(!entry) return
    return `${this.mapProductToCreditsName(entry.product.mappedId)}: ${entry.amount}`;
  }

  private mapProductToCreditsName(productCode: string) {
    switch (productCode) {
      case "credit-en-r3": return "Callan English 3rd Edition";
      case "credit-en": return "Callan English 2nd Edition";
      case "credit-sp": return "Callan Español";
      case "credit-bs": return "Callan for Business";
      case "credit-cfk": return "Callan for Kids";
    }
    return "unknown credit type";
  }
}
